import Axios from 'axios'
import objectToFormData from 'object-to-formdata'
import store from '../store'
 export default {

     install(Vue, options) {
          Vue.prototype.$Login = function(url, data)  {
               return new Promise((res, rej) => {
                    Axios.post(url, data).then((response) => {

                         res(response)
                         console.log('responseresponse', response);
                         
                         localStorage.setItem('AZDFDdsSDSJ21SSDO', response.data.access_token)
                         localStorage.setItem('ADSDIS458SZDF54S7', response.data.access_token_vip)
                         localStorage.setItem('HUDS45DSSKCVZEZFG', response.data.user.fullname)
                         localStorage.setItem('HU88fd9DFDFJIJJDFD', response.data.user.id)
                         localStorage.setItem('LMLVCVPPIDFDdKOSDS', response.data.user.fullnameArab)
                         localStorage.setItem('DSHUZDPSDSPDSJSU4', response.data.user.n_labo)

                         
                         Axios.defaults.headers.common = {
                              "X-Requested-With": "XMLHttpRequest",
                              "Authorization": `Bearer ${ localStorage.getItem('AZDFDdsSDSJ21SSDO')}`
                         }

                         localStorage.getItem('lang') == 'fr' ? toastr.success('Bienvenue dans le panneau de contrôle', 'Succés') : toastr.success('مرحبًا بك في لوحة التحكم', 'رساله ترحيب')
                         
 
                    }).catch((error) => {
                         
                         localStorage.getItem('lang') == 'fr' ? toastr.error("Les informations sont fausses ou vous n'avez pas de pouvoirs", 'ERREUR') : toastr.error("المعلومات خاطئة أو ليس لديك الصلاحيات", 'خطأ')

                         rej(error)
                    })
               })
          }

          Vue.prototype.$LoginWithNip = function (url, data) {
               return new Promise((res, rej) => {
                    Axios.post(url, data).then((response) => {

                         res(response)
                         console.log('responseresponse', response);

                         localStorage.setItem('IJIFS7854KOKSDOKO', response.data.access_token) 
                         localStorage.setItem('POEJUGUR74SFJOJOG', response.data.user.nom_complet)
                         localStorage.setItem('GRRSGOIGDRGOOKOOF', '458'+response.data.user.id+'H7F7F4') 


                         Axios.defaults.headers.common = {
                              "X-Requested-With": "XMLHttpRequest",
                              "Authorization": `Bearer ${ localStorage.getItem('AZDFDdsSDSJ21SSDO')}`
                         }

                         localStorage.getItem('lang') == 'fr' ? toastr.success('Bienvenue dans le panneau de contrôle', 'Succés') : toastr.success('مرحبًا بك في لوحة التحكم', 'رساله ترحيب')


                    }).catch((error) => {

                         localStorage.getItem('lang') == 'fr' ? toastr.error("Les informations sont fausses", 'ERREUR') : toastr.error("المعلومات خاطئة أو ليس لديك الصلاحيات", 'خطأ')

                         rej(error)
                    })
               })
          }
   
          Vue.prototype.$LogOut = function (url) {
               return new Promise((res, rej) => {
                    Axios.post(url, {
                         headers: {
                              "X-Requested-With": "XMLHttpRequest",
                              "Authorization": `Bearer ${ localStorage.getItem('AUWXYZJOD')}`
                         }
                    }).then((respons) => {

                         localStorage.removeItem('AZDFDdsSDSJ21SSDO')
                         // localStorage.removeItem('idLabo')
                         localStorage.removeItem('ADSDIS458SZDF54S7')
                         localStorage.removeItem('HUDS45DSSKCVZEZFG')
                         localStorage.removeItem('LMLVCVPPIDFDdKOSDS')
                         localStorage.removeItem('HU88fd9DFDFJIJJDFD')

                         res(respons)
                    }).catch((error) => {
                         rej(error)
                    })
               })
          } 
          Vue.prototype.$Register = function (data, url, commit) {
               return new Promise((res, rej) => {
                    Axios.post(BACKEND_URL + url , data, { 

                              transformRequest: [function(dat, headers) {
                              return objectToFormData(dat)
                              }],
                              onUploadProgress: e => {}
                    }).then((data) => {
                         if(data) {
                              if(data.data.res != undefined) {
                                   var obj = Object.keys(data.data)[0]
                              } else {
                                   var obj = Object.keys(data.data)
                              }
                              console.log('obj', obj)
                              if(obj == "success") {
                                   if (Object.values(data.data) == 'enregistrer') {
                                      localStorage.getItem('lang') == 'fr' ? toastr.success("Enregistrer avec succès", "succès") : toastr.success("تم الإضافة بنجاح", "نجاح")
                                   }
                                   if (Object.values(data.data) == 'delImg') {
                                        localStorage.getItem('lang') == 'fr' ? toastr.success("Cet image a supprimé avec Succès", "succès") : toastr.success("تم حذف هذه الصورة بنجاح", "نجاح")
                                   }
                                   store.commit(commit)
                                   res(data.data)
                              } else if(obj == "Error") {
                                 if(Object.values(data.data) == 'remplissezTitre') {
                                       localStorage.getItem('lang') == 'fr' ? toastr.warning("Remplissez le titre et le titre en arabe..!", "succès") : toastr.warning("املأ العنوان والعنوان باللغة العربية ..!", "نجاح")
                                 }
                                 if(Object.values(data.data) == 'remplissezParag') {
                                       localStorage.getItem('lang') == 'fr' ? toastr.warning("Remplissez au moins un paragraphe et un paragraphe en arabe..!", "succès") : toastr.warning("املأ فقرة واحدة على الأقل وفقرة واحدة باللغة العربية ..!", "نجاح")
                                 }
                                   rej(arr)
                              } else if(obj == "Warning") {
                                   
                                   if (Object.values(data.data) == 'Rienchanger'){
                                        localStorage.getItem('lang') == 'fr' ? toastr.warning("Rien à changer", "Avertissement") : toastr.warning("لا شيء يتغير", "تحذير")
                                   }
                                   if (Object.values(data.data) == 'selectNews') {
                                        localStorage.getItem('lang') == 'fr' ? toastr.warning("Sélectionner l'élément en premier", "Avertissement") : toastr.warning("حدد البند أولاً", "تحذير")
                                   } 
                              } else {
                                   let arr = Object.values(data.data)[0]
                                   Object.values(arr).forEach(element => {
                                        toastr.error(element[0], "Error")
                                   })
                                   rej(err)
                              }
                         }
                    }).catch(err => {
                         rej(err)
                    })
               })
          }

          Vue.prototype.$Register2 = function (data, url, commit) {
               return new Promise((res, rej) => {
                    Axios.post(USER_BACKEND_URL + url, data, {

                              transformRequest: [function(dat, headers) {
                              return objectToFormData(dat)
                              }],
                              onUploadProgress: e => {}
                    }).then((data) => {
                         store.commit(commit)
                         if(data) {
                              if(data.data.res != undefined) {
                                   var obj = Object.keys(data.data)[0]
                              } else {
                                   var obj = Object.keys(data.data)
                              }

                              if (obj == "result") {
                                   res(data)
                                    localStorage.getItem('lang') == 'fr' ? toastr.success("Obtenir des résultats avec succès", "succès") : toastr.success("الحصول على نتيجة بالنجاح", "نجاح")
                              } else if (obj == "errors") {
                                   rej(data)
                                   let arr = Object.values(data.data)[0]
                                   Object.values(arr).forEach(element => {
                                        toastr.error(element[0], "Error")
                                   })
                                   rej(err)
                              }
                                if (obj == "Warning") {

                                     toastr.warning(Object.values(data.data), Object.keys(data.data));
                                     rej(arr)
                                }
                         }
                    }).catch(err => {
                         rej(err)
                    })
               })
          }

          Vue.prototype.$Delete = function (id, url, commit) {
               console.log(id);
               
               if (id.id == 0) {
                     localStorage.getItem('lang') == 'fr' ? toastr.warning("Rien à changer", "Avertissement") : toastr.warning("لا شيء يتغير", "تحذير")
               } else {
                    Fire.$swal({
                         title: localStorage.getItem('lang') == 'fr' ? 'Être vous sur ?' : 'هل انت متأكد؟',
                         text: localStorage.getItem('lang') == 'fr' ? "Toutes vos informations seront supprimées!" : "سيتم حذف جميع التغييرات الخاصة بك!",
                         icon: localStorage.getItem('lang') == 'fr' ? 'warning' : 'تحذير',
                         showCancelButton: false,
                         confirmButtonColor: '#3085d6',
                         cancelButtonColor: '#d33',
                         confirmButtonText: localStorage.getItem('lang') == 'fr' ? 'Oui, supprimez-le!' : 'نعم ، احذفه!'
                    }).then((result) => {
                         if (result.value) {
                              return new Promise((res, rej) => {
                              Axios.post(BACKEND_URL + url, id).then((data) => {
                                   
                                   Fire.$swal(
                                        localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
                                        
                                        localStorage.getItem('lang') == 'fr' ? 'success' : 'نجاح'
                                        );
                                         store.commit(commit) 
                                        res(data)
                                   }).catch((erre) => {
                                        
                                        Fire.$swal(
                                             localStorage.getItem('lang') == 'fr' ? 'Impossible de supprimer cet élément. :(' : 'لا يمكن حذف هذا العنصر. :(',
                                             erre,
                                             localStorage.getItem('lang') == 'fr' ? 'error' : 'خطأ'
                                             );
                                             
                                        });
                                   })
                                   } 
                              })
                         }
          }
 
      
          Vue.mixin({
               methods: {
                    checkDefault(item) {
                         for (let i = 0; i < this.website.length; i++) {
                              if (this.website[i].elementName == item) {
                                   return this.website[i]
                              }
                         }
                    },
                   getName(name) {
                        return this.localLang == "fr" ? (this.checkDefault(name) ? this.checkDefault(name).nameFr : '') : (this.checkDefault(name).nameAr ? this.checkDefault(name).nameAr : '')
                   },
               },
               computed: {
                    myArray2() {
                              var arr = []
                              let set = new Set();
                              this.pages.filter(e => {
                                   if (!set.has(e.route)) {
                                        arr.push(e)
                                   }
                                   set.add(e.route)
                              })
                              return arr
                         },

                         pages() {
                              return this.$store.state.pages
                         },
                    myArray() {
                         var arr = []
                         let set = new Set();
                         this.website.filter(e => {
                              if (!set.has(e.elementName)) {
                                   arr.push(e)
                              }
                              set.add(e.elementName)
                         })
                         return arr
                    },
                     sections() {
                          return this.$store.state.sections
                     },
                      status() {
                         return this.$store.state.status
                    },
                    website() {
                          console.log('params', this.$route)
                         if(this.$route.name == 'vip') {
                              return this.$store.state.website.filter(e => e.idPage = 1)
                          }
                          else if(this.$route.name == 'services') {
                              return this.$store.state.website.filter(e => e.idPage = 2)
                          }
                          else if(this.$route.name == 'vosResult') {
                              return this.$store.state.website.filter(e => e.idPage = 3)
                          }
                          else if(this.$route.name == 'galeri') {
                              return this.$store.state.website.filter(e => e.idPage = 4)
                          }
                          else if(this.$route.name == 'conseil') {
                              return this.$store.state.website.filter(e => e.idPage = 5)
                          }
                          else if(this.$route.name == 'contact') {
                              return this.$store.state.website.filter(e => e.idPage = 6)
                          }
                          else if(this.$route.name == 'news') {
                              return this.$store.state.website.filter(e => e.idPage = 7)
                          }
                          else if(this.$route.name == 'detailsNews') {
                              return this.$store.state.website.filter(e => e.idPage = 8)
                          } else   {
                               return this.$store.state.website
                          }
                    },
                    settings() {
                         return this.$store.state.settings
                    },
                    isLoading() {
                         console.log('this.$store.state.isLoadings', this.$store.state.isLoadings)
                         return this.$store.state.isLoadings
                    },
                    localLang() {
                         return this.$i18n.locale
                    },
                    wilaya() {
                         return this.$store.state.wilaya
                    },
                    commune2() {
                         return this.$store.state.commune
                    },
                    getWilaya() {
                         if (this.settings[0] && this.wilaya && this.localLang == "fr") {
                              return this.wilaya.find(e => e.id == this.settings[0].wilaya_id) ? this.wilaya.find(e => e.id == this.settings[0].wilaya_id)["name_fr"] : ''
                         } else if (this.settings[0] && this.wilaya && this.localLang == "ar") {
                              return this.wilaya.find(e => e.id == this.settings[0].wilaya_id) ? this.wilaya.find(e => e.id == this.settings[0].wilaya_id)["name_ar"] : ''
                         } else {
                              return '--------------'
                         }
                    },
                    getCommune() {
                         if (this.settings[0] && this.commune2 && this.localLang == "fr") {
                              return this.commune2.find(e => e.id == this.settings[0].commune_id) ? this.commune2.find(e => e.id == this.settings[0].commune_id)["nom"] : ''
                         } else if (this.settings[0] && this.wilaya && this.localLang == "ar") {
                              return this.commune2.find(e => e.id == this.settings[0].commune_id) ? this.commune2.find(e => e.id == this.settings[0].commune_id)["nom"] : ''
                         } else {
                              return '--------------'
                         }
                    },
               },
               created() {
                   
               }

          })

     }

}